import { render, staticRenderFns } from "./EventsPreview.vue?vue&type=template&id=7b6bcefb"
import script from "./EventsPreview.vue?vue&type=script&lang=js"
export * from "./EventsPreview.vue?vue&type=script&lang=js"
import style0 from "./EventsPreview.vue?vue&type=style&index=0&id=7b6bcefb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports